import { render, staticRenderFns } from "./MyTags.vue?vue&type=template&id=309f0bc3&lang=pug&"
import script from "./MyTags.vue?vue&type=script&lang=js&"
export * from "./MyTags.vue?vue&type=script&lang=js&"
import style0 from "./MyTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports